import { lazyLoad } from "utils/loadable";

const MonthlySchedulePage = lazyLoad(
  () => import("./index"),
  (module) => module.MonthlySchedulePage,
  {
    fallback: (
      <div>
        <p>Loading....</p>
      </div>
    ),
  }
);

export default MonthlySchedulePage;
